import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoFilesGetRes } from "./abst/DtoFilesGetRes";

export class DtoFilesGetResImple extends DtoFilesGetRes {
  public pager = new DtoApiPager();
  public url: string | null = null;
}
